import { Component, OnInit, Input, Output, EventEmitter, AfterContentInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppFacadeService } from '@services/app-facade.service';
import { UserBusinessModel, UserModel } from '@models/index';
import { Role } from '@enums/role.enum';
import { EntitiesEnum } from '@enums/entities.enum';
import Swal from 'sweetalert2';

import { NgxPermissionsService } from 'ngx-permissions';

@Component({
  selector: 'app-user-business-table',
  templateUrl: './user-business-table.component.html',
  styleUrls: ['./user-business-table.component.sass']
})

export class UserBusinessTableComponent implements OnInit, AfterContentInit {
  @Input() users: UserBusinessModel[];
  @Input() page: number;
  @Input() pageSize: number;
  @Input() showReseller: boolean = false;
  @Input() showNoResults: boolean = false;
  @Input() entity: string;
  @Output() delete = new EventEmitter<UserBusinessModel>();
  @Output() resend = new EventEmitter<UserBusinessModel>();
  @Output() businessRoleChange = new EventEmitter();
  @Output() resellerRoleChange = new EventEmitter();
  @Output() edit = new EventEmitter();

  loggedUser$ = this.appFacadeService.getLoggedUser$();
  loggedUser: UserModel;
  businessRoles$ = this.appFacadeService.getUserRoles$().pipe(
    map(roles => roles.filter(role => role.shortName === 'BSAD' || role.shortName === 'BSUSR'))
  );
  resellerRoles$ = this.appFacadeService.getUserRoles$().pipe(
    map(roles => roles.filter(role => role.shortName === 'RSLAD'))
  );

  roleEnum = Role;
  entities = EntitiesEnum;

  permissions: any;

  constructor(
    private appFacadeService: AppFacadeService,
    private permissionsService: NgxPermissionsService
  ) { }

  ngOnInit() { 
    this.permissions = this.permissionsService.getPermissions()
  }
  
  ngAfterContentInit() {
    this.appFacadeService.searchUserRoles();
    this.loggedUser$.subscribe(user => { this.loggedUser = user })
  }

  deleteUser(user: UserBusinessModel) {
    this.delete.emit(user)
  }

  editUser(user: UserBusinessModel) {
    this.edit.emit(user)
  }
}
